export default "__VITE_ASSET__DEOIWVZJ__"